"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _buttonRadioGroupModule = _interopRequireDefault(require("./buttonRadioGroup.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ButtonRadioGroup = function ButtonRadioGroup(props) {
  var items = props.items,
      _onClick = props.onClick,
      value = props.value,
      style = props.style,
      disabled = props.disabled,
      required = props.required,
      name = props.name;
  return _react.default.createElement("div", {
    className: _buttonRadioGroupModule.default["groupWrapper"]
  }, _react.default.createElement("div", {
    className: _buttonRadioGroupModule.default["groupWrapper__options-container"]
  }, items.map(function (item, index) {
    return _react.default.createElement("div", {
      className: _buttonRadioGroupModule.default["groupWrapper__option-container"],
      key: "".concat(index, "__").concat(item.label)
    }, _react.default.createElement("div", {
      className: (0, _classnames.default)(_buttonRadioGroupModule.default["senary"], item && item.value === value ? _buttonRadioGroupModule.default["active"] : ''),
      style: _objectSpread({}, style)
    }, _react.default.createElement("label", null, item.label), _react.default.createElement("input", {
      type: 'radio',
      name: name,
      required: required,
      checked: item && item.value === value,
      onClick: function onClick() {
        return _onClick(item);
      },
      disabled: disabled,
      value: item.value
    })), _react.default.createElement("p", {
      className: _buttonRadioGroupModule.default["groupWrapper__option-label"]
    }, item.description ? item.description : null));
  })));
};

ButtonRadioGroup.propTypes = {
  /** Required if the button is of type button */
  onClick: _propTypes.default.func,

  /** items displays in the row */
  items: _propTypes.default.object,

  /** string or number indicates witch button is selected **/
  value: _propTypes.default.any,

  /** additional style **/
  style: _propTypes.default.any,

  /** Boolean indicating if the component is required  */
  required: _propTypes.default.bool,

  /** The name attribute of the element */
  name: _propTypes.default.string.isRequired,

  /** Boolean indicating if the component is disabled  */
  disabled: _propTypes.default.bool
};
var _default = ButtonRadioGroup;
exports.default = _default;